// collegesData.js
export const collegesData = {
    Bihar: [
      {
        "id": 1,
        "nirf": 1,
        "found": 1959,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Muzaffarpur Institute of Technology, Muzaffarpur",
        "link": "#"
      },
      {
        "id": 2,
        "nirf": 2,
        "found": 1960,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Bhagalpur College of Engineering, Bhagalpur",
        "link": "#"
      },
      {
        "id": 3,
        "nirf": 3,
        "found": 1961,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Darbhanga College of Engineering, Darbhanga",
        "link": "#"
      },
      {
        "id": 4,
        "nirf": 4,
        "found": 1962,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Gaya College of Engineering, Gaya",
        "link": "#"
      },
      {
        "id": 5,
        "nirf": 5,
        "found": 1963,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Nalanda College of Engineering, Chandi",
        "link": "#"
      },
      {
        "id": 6,
        "nirf": 6,
        "found": 1964,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Motihari College of Engineering, Motihari",
        "link": "#"
      },
      {
        "id": 7,
        "nirf": 7,
        "found": 1965,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Loknayak Jai Prakash Institute of Technology, Chapra",
        "link": "#"
      },
      {
        "id": 8,
        "nirf": 8,
        "found": 1966,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Rashtrakavi Ramdhari Singh Dinkar College of Engineering, Begusarai",
        "link": "#"
      },
      {
        "id": 9,
        "nirf": 9,
        "found": 1967,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Katihar Engineering College, Katihar",
        "link": "#"
      },
      {
        "id": 10,
        "nirf": 10,
        "found": 1968,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Purnea College of Engineering, Purnea",
        "link": "#"
      },
      {
        "id": 11,
        "nirf": 11,
        "found": 1969,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Supaul College of Engineering, Supaul",
        "link": "#"
      },
      {
        "id": 12,
        "nirf": 12,
        "found": 1970,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Sitamarhi Institute of Technology, Sitamarhi",
        "link": "#"
      },
      {
        "id": 13,
        "nirf": 13,
        "found": 1971,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Bakhtiyarpur College of Engineering, Bakhtiyarpur",
        "link": "#"
      },
      {
        "id": 14,
        "nirf": 14,
        "found": 1972,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "B P Mandal College of Engineering, Madhepura",
        "link": "#"
      },
      {
        "id": 15,
        "nirf": 15,
        "found": 1973,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Sershah Engineering College, Sasaram",
        "link": "#"
      },
      {
        "id": 16,
        "nirf": 16,
        "found": 1974,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Saharsa College of Engineering, Saharsa",
        "link": "#"
      },
      {
        "id": 17,
        "nirf": 17,
        "found": 1975,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Vaishali",
        "link": "#"
      },
      {
        "id": 18,
        "nirf": 18,
        "found": 1976,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Jamui",
        "link": "#"
      },
      {
        "id": 19,
        "nirf": 19,
        "found": 1977,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Banka",
        "link": "#"
      },
      {
        "id": 20,
        "nirf": 20,
        "found": 1978,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Nawada",
        "link": "#"
      },
      {
        "id": 21,
        "nirf": 21,
        "found": 1979,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Kishanganj",
        "link": "#"
      },
      {
        "id": 22,
        "nirf": 22,
        "found": 1980,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Araria",
        "link": "#"
      },
      {
        "id": 23,
        "nirf": 23,
        "found": 1981,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Munger",
        "link": "#"
      },
      {
        "id": 24,
        "nirf": 24,
        "found": 1982,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Sheohar",
        "link": "#"
      },
      {
        "id": 25,
        "nirf": 25,
        "found": 1983,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, West Champaran",
        "link": "#"
      },
      {
        "id": 26,
        "nirf": 26,
        "found": 1984,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Aurangabad",
        "link": "#"
      },
      {
        "id": 27,
        "nirf": 27,
        "found": 1985,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College,Kaimur",
        "link": "#"
      },
      {
        "id": 28,
        "nirf": 28,
        "found": 1986,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College,Gopalganj",
        "link": "#"
      },
      {
        "id": 29,
        "nirf": 29,
        "found": 1987,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Madhubani",
        "link": "#"
      },
      {
        "id": 30,
        "nirf": 30,
        "found": 1988,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College of Siwan",
        "link": "#"
      },
      {
        "id": 31,
        "nirf": 31,
        "found": 1989,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Jehnabad",
        "link": "#"
      },
      {
        "id": 32,
        "nirf": 32,
        "found": 1990,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Arwal",
        "link": "#"
      },
      {
        "id": 33,
        "nirf": 33,
        "found": 1991,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College of Khagaria",
        "link": "#"
      },
      {
        "id": 34,
        "nirf": 34,
        "found": 1992,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Buxar",
        "link": "#"
      },
      {
        "id": 35,
        "nirf": 35,
        "found": 1993,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Bhojpur",
        "link": "#"
      },
      {
        "id": 36,
        "nirf": 33,
        "found": 1991,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Shekhpura",
        "link": "#"
      },
      {
        "id": 37,
        "nirf": 34,
        "found": 1992,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Lakhisarai",
        "link": "#"
      },
      {
        "id": 38,
        "nirf": 35,
        "found": 1993,
        "logo": "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        "build": "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        "name": "Government Engineering College, Samastipur",
        "link": "#"
      } 
    ]
    ,
    Andhra_Pradesh: [
      {
        id: 1100,
        nirf: 1,
        found: 1959,
        logo: "https://pnghq.com/wp-content/uploads/2023/02/iit-madras-logo-png-4172-768x768.png",
        build: "https://theindianwire.com/wp-content/uploads/2019/01/IIT-Madras.jpg",
        name: "Bhagalpur College of Engineering,Bhagalpur",
        link: "#",
      },
      // More colleges...
    ],
    // More states...
  };
  